<div class="scroll-container">
  @if(items()){
    @for(item of items(); track getTrackingValue(item)) {
      <mat-card class="item-card" (click)="onCardClick(item)" appearance="outlined">
        @if(headerTemplate) {
          <ng-container *ngTemplateOutlet="headerTemplate; context: {$implicit: item}" />
        }
        @else {
          <mat-card-header>
            <mat-card-title>{{displayFn(item)}}</mat-card-title>
            <mat-card-subtitle>{{displaySubTitle(item)}}</mat-card-subtitle>
          </mat-card-header>
        }

        <mat-card-content>
          <ng-container *ngTemplateOutlet="bodyTemplate; context: {$implicit: item}" />
        </mat-card-content>
      </mat-card>
    }
  }
  @else if (cardDataList())
  {
    @for(card of cardDataList(); track card?.title) {
      <mat-card class="item-card" (click)="onCardClick(card)">
        @if(card.headerTemplate) {
          <ng-container *ngTemplateOutlet="card.headerTemplate; context: {$implicit: card}" />
        }
        @else {
          <mat-card-header>
            <mat-card-title class="mx-2">{{card.title}}</mat-card-title>
            @if(card.subtitle) {
              <mat-card-subtitle>{{card.subtitle}}</mat-card-subtitle>
            }
          </mat-card-header>
        }

        <mat-card-content>
          @if(card.body){
            {{card.body}}
          }
          @else {
            <ng-container *ngTemplateOutlet="card.bodyTemplate; context: {$implicit: card}" />
          }

        </mat-card-content>
      </mat-card>
    }
  }
  @else {
    <mat-card class="no-items-card">
      <mat-card-content>
        {{ noItemsMessage() }}
      </mat-card-content>
    </mat-card>
  }
</div>
